<template>
<div class="fourth">
  <div class="fourth_bg"></div>
  <div class="shui_haohe"></div>
  <div class="shui_yu"></div>
  <div class="shui_muchang"></div>
  <div class="title"></div>
  <div class="title2"></div>
  <div class="title3"></div>
  <div class="title4"></div>

<!--  濠河水-->
  <div class="wave wave01"></div>
  <div class="wave wave02"></div>
  <div class="wave wave03"></div>

<!--  荷花池中的水-->
  <div class="wave wave_hehua03"></div>
  <div class="wave wave_hehua04"></div>
  <div class="wave wave_hehua05"></div>
  <div class="wave wave_hehua06"></div>
  <div class="wave wave_hehua07"></div>
  <div class="wave wave_hehua08"></div>



<!--  gif部分-->
  <div class="chitao"></div>
  <div class="diaoyu"></div>

<!--  小樽好好吃哦-->
  <div class="liukoushui"></div>
  <div class="liukoushuigif"></div>
  <div class="liukoushui_png"></div>

  <div class="baozi"></div>

<!--  小樽拍照茄子-->
  <div class="qiezi"></div>
  <div class="qiezi_png"></div>

  <div class="niu"></div>

<!--  新鲜家族-->
  <div class="xxjz"></div>
  <div class="g1"></div>
  <div class="g2"></div>
  <div class="g3"></div>
  <div class="g4"></div>
  <div class="g5"></div>
  <div class="g6"></div>
  <div class="qizhi"></div>

  <div class="lorry"></div>
  <div class="milk-y"></div>
<!--  <div class="zhijian"></div>-->
<!--  <div class="superMarket"></div>-->

<!--  <div class="snow1 pos1 snowfall"></div>-->
<!--  <div class="snow2 pos2 snowfall"></div>-->
<!--  <div class="snow1 pos3 snowfall"></div>-->
<!--  <div class="snow1 pos4 snowfall"></div>-->
<!--  <div class="snow1 pos5 snowfall"></div>-->
<!--  <div class="snow2 pos6 snowfall"></div>-->
<!--  <div class="snow1 pos7 snowfall"></div>-->
<!--  <div class="snow2 pos8 snowfall"></div>-->
</div>
</template>

<script>
export default {
  name: "fourth.vue"
}
</script>

<style scoped>
@import "../animationcss/animatie.css";
.fourth{
  width: 750px;
  height: 4877px;
  position: relative;
}
.fourth_bg{
  width: 750px;
  height: 4877px;
  background: url("../../public/guangming_milk/4/4_bg5.png") no-repeat;
  background-size: 100% 100%;
  background-position: 0 -58px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
}
.shui_haohe{
  width: 750px;
  height: 477px;
  background: url("../../public/guangming_milk/4/shui_haohe.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top:225px;
  z-index: 2;
}
.shui_yu{
  width: 750px;
  height: 820px;
  background: url("../../public/guangming_milk/4/shui_yu2.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: 952px;
  z-index: 2;
}
.shui_muchang{
  width: 750px;
  height: 95px;
  background: url("../../public/guangming_milk/4/shui_muchang.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: 2782px;
  z-index: 2;
}
.fourth .title{
  width: 358px;
  height: 173px;
  background:url('../../public/guangming_milk/title/4_title.png')  no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: calc(50% - 160px);
  top: 348px;
  z-index: 6;
}
.fourth .title2{
  width: 348px;
  height: 126px;
  background:url('../../public/guangming_milk/title/4_title2.png')  no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 0px;
  top: 2090px;
  z-index: 6;
}
.fourth .title3{
  width: 300px;
  height: 219px;
  background:url('../../public/guangming_milk/title/4_title3.png')  no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 0;
  top: 2760px;
  z-index: 6;
}
.fourth .title4{
  width: 378px;
  height: 127px;
  background: url('../../public/guangming_milk/title/4_title4.png') no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: calc(50% - 189px);
  top: 4000px;
  z-index: 6;
}
/*濠河水水水水水水水水水水*/
.wave{
  width: 316px;
  height: 36px;
  background: url("../../public/guangming_milk/png/wave.png")no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 3;
}
.wave01{
  top: 268px;
  left: 200px;
  -webkit-animation: wave 2s linear infinite;
  -moz-animation: wave 2s linear infinite;
  -o-animation: wave 2s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}.wave02{
  top: 294px;
  left: 200px;
  -webkit-animation: wave2 2s linear infinite;
  -moz-animation: wave2 2s linear infinite;
  -o-animation: wave2 2s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}.wave03{
  top: 326px;
  left: 280px;
  -webkit-animation: wave3 2s linear infinite;
  -moz-animation: wave3 2s linear infinite;
  -o-animation: wave3 2s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
 .wave_hehua03{
   top: 993px;
   left: -67px;
   -webkit-animation: wave3 2s linear infinite;
   -moz-animation: wave3 2s linear infinite;
   -o-animation: wave3 2s linear infinite;
   -webkit-transform: translate3d(0, 0, 0);
   -moz-transform: translate3d(0, 0, 0);
   -o-transform: translate3d(0, 0, 0)
 }
 .wave_hehua04{
   top: 1065px;
   left: 157px;
   -webkit-animation: wave 1s linear infinite;
   -moz-animation: wave 1s linear infinite;
   -o-animation: wave 1s linear infinite;
   -webkit-transform: translate3d(0, 0, 0);
   -moz-transform: translate3d(0, 0, 0);
   -o-transform: translate3d(0, 0, 0)
 }.wave_hehua05{
   top: 1117px;
   left: 225px;
   -webkit-animation: wave3 1s linear infinite;
   -moz-animation: wave3 1s linear infinite;
   -o-animation: wave3 1s linear infinite;
   -webkit-transform: translate3d(0, 0, 0);
   -moz-transform: translate3d(0, 0, 0);
   -o-transform: translate3d(0, 0, 0)
 }.wave_hehua06{
   top: 997.5px;
   left: 472.5px;
   -webkit-animation: wave2 1s linear infinite;
   -moz-animation: wave2 1s linear infinite;
   -o-animation: wave2 1s linear infinite;
   -webkit-transform: translate3d(0, 0, 0);
   -moz-transform: translate3d(0, 0, 0);
   -o-transform: translate3d(0, 0, 0)
 }.wave_hehua07{
   top: 1237.5px;
   left: 382.5px;
   -webkit-animation: wave2 1.5s linear infinite;
   -moz-animation: wave2 1.5s linear infinite;
   -o-animation: wave2 1.5s linear infinite;
   -webkit-transform: translate3d(0, 0, 0);
   -moz-transform: translate3d(0, 0, 0);
   -o-transform: translate3d(0, 0, 0)
 }.wave_hehua08{
   top: 1305.5px;
   left: 277.5px;
   -webkit-animation: wave3 1.2s linear infinite;
   -moz-animation: wave3 1.2s linear infinite;
   -o-animation: wave3 1.2s linear infinite;
   -webkit-transform: translate3d(0, 0, 0);
   -moz-transform: translate3d(0, 0, 0);
   -o-transform: translate3d(0, 0, 0)
 }


@keyframes wave{
  0%{
    transform: translateY(0px);
  }
  25%{
    transform: translateY(4px);
  }
  40%{
    transform: translateY(-4px);
  }
  60%{
    transform: translateY(0px);
  }
  80%{
    transform: translateY(-4px);
  }
  100%{
    transform: translateY(0px);
  }
}
@keyframes wave2 {
  50%{transform:translateY(4px)}
}
@keyframes wave3 {
  50%{transform:translateY(8px)}
}


.chitao{
  width: 474px;
  height: 330px;
  background: url("../../public/guangming_milk/4/chitao2.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 6;
  top: 778.5px;
  left: 19px;
}
.diaoyu{
  width: 55px;
  height: 202px;
  background: url("../../public/guangming_milk/4/diaoyu2.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 6;
  top: 1505px;
  left: 412px;
}
.liukoushui{
  width: 204px;
  height: 409px;
  background: url("../../public/guangming_milk/4/liukoushuix2.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 6;
  top: 1687.5px;
  right: 19.95px;
}
.liukoushuigif{
  width: 120px;
  height: 110px;
  background: url("../../public/guangming_milk/4/liukoushuix2.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 6;
  top: 1808px;
  right: 77px;
}
.liukoushui_png{
  /*好好吃喔*/
  width: 219px;
  height: 114px;
  background: url("../../public/guangming_milk/4/liukoushui_png.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 6;
  top: 1717px;
  right: 220px;
  animation: showNoice 1.8s linear infinite;

}
@keyframes  showNoice{
  from{opacity: 0}
  to{opacity: 1}
}
.baozi{
  width: 222px;
  height: 284px;
  background: url("../../public/guangming_milk/4/baozi2.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 6;
  top: 1498px;
  left: 85px;
}
.qiezi{
  width: 300px;
  height: 361px;
  background: url("../../public/guangming_milk/4/qiezi2.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 6;
  top: 2398px;
  left: 22px;
}
.qiezi_png{
  width: 119px;
  height: 95px;
  background: url('../../public/guangming_milk/4/qiezi_png.png') no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 6;
  top: 2430px;
  left: 300px;
  animation: showNoice 1.3s linear infinite;
}

.niu{
  width: 686px;
  height: 521px;
  background: url("../../public/guangming_milk/4/niu2.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 5;
  top: 3097.5px;
  left: 65px;
}
.xxjz{
  width: 727px;
  height: 661px;
  background: url("../../public/guangming_milk/4/xxjz.png");
  background-size: 100% 100%;
  position: absolute;
  z-index: 7;
  top: 3330px;
  left: 5px;
}
.g1{
  width: 30px;
  height: 30px;
  background: url("../../public/guangming_milk/4/g1.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 7;
  top: 3408px;
  left: 176px;
}.g2{
  width: 30px;
  height: 20px;
  background: url("../../public/guangming_milk/4/g2.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 7;
  top: 3548px;
  left: 123px;
}.g3{
  width: 70px;
  height: 30px;
  background: url("../../public/guangming_milk/4/g3.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 7;
  top: 3758.5px;
  left: 115px;
}.g4{
  width: 20px;
  height: 18px;
  background: url("../../public/guangming_milk/4/g4.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 7;
  top: 3809px;
  left: 318px;
}.g5{
  width: 62px;
  height: 40px;
  background: url("../../public/guangming_milk/4/g5.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 7;
  top: 3859px;
  left: 442px;
}.g6{
  width: 60px;
  height: 60px;
  background: url("../../public/guangming_milk/4/g6.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 7;
  top: 3706px;
  left: 569px;
}

.lorry{
  width: 750px;
  height: 764px;
  background: url("../../public/guangming_milk/4/4-lorry-5.gif");
  background-size: 100% 100%;
  position: absolute;
  z-index: 10;
  bottom: -17px;
  left: 0;
}
.milk-y{
  width: 147px;
  height: 256px;
  background: url("../../public/guangming_milk/4/niuy.jpg");
  background-size: 100% 100%;
  position: absolute;
  z-index: 12;
  bottom: 491px;
  left: 0;
}
.zhijian{
  width: 152px;
  height: 121px;
  background: url("../../public/guangming_milk/4/zhijian.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 11;
  bottom: 569px;
  left: 174px;
}
.superMarket{
  width: 174px;
  height: 40px;
  background: url("../../public/guangming_milk/4/supermarket.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 11;
  right: 102px;
  bottom: 180px;
}

.snow1{
  width: 94px;
  height: 84px;
  background: url("../../public/guangming_milk/png/snow.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 50;
}.snow2{
  width: 18px;
  height: 18px;
  background: url("../../public/guangming_milk/png/snow2.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 50;
}
.pos1{
  bottom: 364px;
  animation: snowDown 5.5s linear infinite normal;
  -webkit-animation: snowDown 5.5s linear infinite normal;
}
.pos2{
  bottom: 388px;
  left: 5%;
  animation: snowDown 4.5s linear infinite normal;
  -webkit-animation: snowDown 4.5s linear infinite normal;
}.pos3{
  bottom: 368px;
  left: 16%;
  animation: snowDown 3.5s linear infinite normal;
  -webkit-animation: snowDown 3.5s linear infinite normal;
}.pos4{
  bottom: 328px;
  left: 26%;
  animation: snowDown 5s linear infinite normal;
  -webkit-animation: snowDown 5s linear infinite normal;
}.pos5{
  bottom: 428px;
  left: 46%;
  animation: snowDown 6.9s linear infinite normal;
  -webkit-animation: snowDown 6.9s linear infinite normal;
}.pos6{
  bottom: 466px;
  left: 66%;
  animation: snowDown 5.9s linear infinite normal;
  -webkit-animation: snowDown 5.9s linear infinite normal;
}.pos7{
  bottom: 466px;
  left: 86%;
  animation: snowDown 7.9s linear infinite normal;
  -webkit-animation: snowDown 7.9s linear infinite normal;
}.pos8{
  bottom: 446px;
  left: 76%;
  animation: snowDown 8.1s linear infinite normal;
  -webkit-animation: snowDown 8.1s linear infinite normal;
}
@keyframes snowDown {
  0% {
    opacity: 1;
  }
  70%{
    opacity: 1;
  }
  100% {
    opacity: 0;
    bottom: 80px;
    transform: rotate(360deg);
  }
}



/*importcss  动！！！！！！！！！！画样式*/


.qizhi {
  width: 340px;
  height: 200px;
  background: url("../../public/guangming_milk/5/flag.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 6;
  top: 3515px;
  left: 235px;
}

</style>
